import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { StudentComment } from './student-comment.model';
import { StudentCommentPopupService } from './student-comment-popup.service';
import { StudentCommentService } from './student-comment.service';
import { CRUD_ACTIONS } from '../../shared';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';

@Component({
    selector: 'jhi-student-comment-delete-dialog',
    templateUrl: './student-comment-delete-dialog.component.html'
})
export class StudentCommentDeleteDialogComponent {

    StudentComment: StudentComment;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private studentCommentService: StudentCommentService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(studentGlobalLocations);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.studentCommentService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'StudentCommentListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-student-comment-delete-popup',
    template: ''
})
export class StudentCommentDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private studentCommentPopupService: StudentCommentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.studentCommentPopupService
                .open(StudentCommentDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment-delete-dialog.component.ts